
<div class="fn-payments">
  <div class="fn-payments__header">
    <div class="fn-payments__header-section-title">
      {{ "IP.SIDENAV.OPTIONS.FINANCE" | translate }}
    </div>
  </div>

  <div class="fn-payments__table">
  <app-ip-table
  [optionalTitle]="'IP.SIDENAV.OPTIONS.FINANCES_OPTIONS.PAYMENTS_ONGOING'"
  [tableOption]="tableOptions"
  [propertyOrder]="propertyOrder"
  (action)="onAction($event)"
  [pageItems]="10"
  [filter]="false"
  service="payments-ongoing"
></app-ip-table>
</div>
</div>



